<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/SqaFkX/tc-custom/9781423608592.jpg?1736883582256" alt="This image is the cover for the book 101 Things To Do With A Dutch Oven, 101 Things To Do With"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">101 Things To Do With A Dutch Oven, 101 Things To Do With
      </h1>
      <p class="bookDescription body article font2">
        <b>A treasury of recipes to make with this simple, classic cooking pot, indoors or out.</b><br/>  <br/> With 101 easy recipes to choose from—ranging from breakfast to dessert, and including breads and rolls—the Dutch oven might just become the most popular cooking method in your house—or outside of it! <br/>  <br/> Recipes in this cookbook include the Mountain Man Breakfast * Sausage Spinach Wreath * Dutch Oven Stew with spicy Jalapeno Cheese Bread * Caramel Apple Cobbler * Stuffed Pork Roast * Cinnamon Rolls * Dutch Oven Pizza * Apricot Raspberry Glazed Cornish Hens * White Chili * and more.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Vernon Winterton
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Gibbs Smith
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?e4e1f118